<div id="orders" class="page-layout carded fullwidth">
    <div class="top-bg primary"></div>

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'QUERY_LOG_LIST' | translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div class="row"></div>
        </div>
        <!-- / HEADER -->
        <div class="content-card my-16" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="date"
                    matSortDirection="desc" fusePerfectScrollbar>

                    <!-- Request Column -->
                    <ng-container matColumnDef="getValue">
                        <mat-header-cell fxFlex="70" *matHeaderCellDef>{{'REQUEST'|translate}}</mat-header-cell>
                        <mat-cell style="justify-content: start;" fxFlex="70" *matCellDef="let query">
                            <p style="white-space: normal;" class="text-truncate">
                                {{query.getValue!=null?query.getValue:"---"}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <!-- Type Column -->
                    <ng-container matColumnDef="type">
                        <mat-header-cell fxFlex="10" *matHeaderCellDef>{{'TYPE'|translate}}
                        </mat-header-cell>
                        <mat-cell fxFlex="10" *matCellDef="let query">
                            <mat-icon *ngIf="query.type==0">cloud_upload</mat-icon>
                            <mat-icon *ngIf="query.type==1">cloud_download</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <!-- date Column -->
                    <ng-container matColumnDef="date">
                        <mat-header-cell fxFlex="20" *matHeaderCellDef>{{'DATE'|translate}}</mat-header-cell>
                        <mat-cell fxFlex="20" *matCellDef="let query">
                            {{query.date!=null?(query.date |date:"dd/MM/y HH:mm"):'---'}}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let query columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>
                <mat-paginator #paginator [length]="pageLenght" (page)="pageEvent($event) " [pageSize]="10"
                    [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>